export default __webpack_public_path__ + "static/media/AnushkaKasera.ced20ec5.jpeg";